import supabase from './database';

const TICKET_TABLE = 'ticket';
const COMMENTS_TABLE = 'commentiticket';

const formatDate = (value) => {
  if (!value) return value;
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;
  return parsed.toLocaleString('it-IT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const formatTicket = (ticket) => ({
  ...ticket,
  Data: formatDate(ticket.Data),
});

const formatComment = (comment) => ({
  ...comment,
  Data: formatDate(comment.Data),
});

export const getTickets = async (filters = {}) => {
  const query = supabase.from(TICKET_TABLE).select('*');

  if (filters.statoIn) {
    query.in('Stato', filters.statoIn);
  }
  if (filters.statoEq !== undefined) {
    query.eq('Stato', filters.statoEq);
  }
  if (filters.autoreEq) {
    query.eq('Autore', filters.autoreEq);
  }

  const { data, error } = await query;
  if (error) throw error;
  return (data || []).map(formatTicket);
};

export const insertTicket = async (payload) => {
  const { data, error } = await supabase
    .from(TICKET_TABLE)
    .insert(payload)
    .select('*')
    .single();
  if (error) throw error;
  return formatTicket(data);
};

export const updateTicket = async (id, payload) => {
  const { error } = await supabase
    .from(TICKET_TABLE)
    .update(payload)
    .eq('ID', id);
  if (error) throw error;
};

export const deleteTicket = async (id) => {
  const { error } = await supabase.from(TICKET_TABLE).delete().eq('ID', id);
  if (error) throw error;
};

export const getComments = async (ticketId) => {
  const { data, error } = await supabase
    .from(COMMENTS_TABLE)
    .select('*')
    .eq('ID_Ticket', ticketId)
    .order('Data', { ascending: true });
  if (error) throw error;
  return (data || []).map(formatComment);
};

export const insertComment = async (payload) => {
  const { data, error } = await supabase
    .from(COMMENTS_TABLE)
    .insert(payload)
    .select('*')
    .single();
  if (error) throw error;
  return formatComment(data);
};

export const deleteComment = async (commentId) => {
  const { error } = await supabase
    .from(COMMENTS_TABLE)
    .delete()
    .eq('ID', commentId);
  if (error) throw error;
};
